import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import queryString from "query-string";
import { OPENDATA } from "../api/request";

const Callback = () => {
  const { search } = useLocation();
  let params = queryString.parse(search);

  if (params.error) {
    window.location = "https://digital.erdenetmc.mn";
  }
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      OPENDATA()
        .post("/auth", {
          code: params.code,
        })
        .then((res) => {
          localStorage.setItem("token", res.data.token);
          window.location.replace("/admin");
        })
        .catch(() => {});
    } else {
      window.location.replace("/admin");
    }
  }, [params.code]);

  return (
    <div className="w-full flex items-center justify-center pt-10">
      Уншиж байна ...
    </div>
  );
};

export default React.memo(Callback);
